import "core-js/modules/es.parse-int.js";
//@ts-ignore
import * as Responsive from './../../styles/settings/responsive.scss';
export var XSMALL = parseInt(Responsive.xsmall);
export var SMALL = parseInt(Responsive.small);
export var MEDIUM = parseInt(Responsive.medium);
export var LARGE = parseInt(Responsive.large);
export var XLARGE = parseInt(Responsive.xlarge);
export var XXLARGE = parseInt(Responsive.xxlarge);
export var RESPONSIVE_SIZES = {
  XSMALL: XSMALL,
  SMALL: SMALL,
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  XLARGE: XLARGE,
  XXLARGE: XXLARGE
};
export var responsiveMediaAbove = function responsiveMediaAbove(size) {
  return window.innerWidth >= RESPONSIVE_SIZES[size];
};
export var responsiveMediaBelow = function responsiveMediaBelow(size) {
  return window.innerWidth < RESPONSIVE_SIZES[size];
};
export var responsiveQuery = function responsiveQuery(size) {
  return "(min-width: ".concat(RESPONSIVE_SIZES[size], "px)");
};